// components/TransactionModals.js
import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import {CATEGORIES} from "../constans";

export const EditTransactionModal = ({ show, transaction, onChange, onClose, onSave, renderSubcategorySelect }) => {
    if (!transaction) return null; // 🔒 безопасно не рендерим модалку

    return (
    <Modal show={!!show} onHide={onClose}>
        <Modal.Header closeButton>
            <Modal.Title>Редагування платежу</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form>
                <Form.Group className="mb-3">
                    <Form.Label>Сума</Form.Label>
                    <Form.Control
                        type="number"
                        value={transaction?.amount / 100}
                        onChange={(e) =>
                            onChange({ ...transaction, amount: Math.round(+e.target.value * 100) })
                        }
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Опис</Form.Label>
                    <Form.Control
                        type="text"
                        value={transaction?.description}
                        onChange={(e) =>
                            onChange({ ...transaction, description: e.target.value })
                        }
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formComment">
                    <Form.Label>Коментар</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={5}
                        placeholder="Коментар"
                        value={transaction?.comment || ""}
                        onChange={(e) =>
                            onChange({ ...transaction, comment: e.target.value })
                        }
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Тип транзакції</Form.Label>
                    <Form.Select
                        value={transaction.direction}
                        onChange={(e) =>
                            onChange({
                                ...transaction,
                                direction: e.target.value,
                            })
                        }
                    >
                        <option value="expense">Витрата</option>
                        <option value="income">Доход</option>
                    </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Категорія</Form.Label>
                    <Form.Select
                        value={transaction?.categoryType}
                        onChange={(e) =>
                            onChange({
                                ...transaction,
                                categoryType: e.target.value,
                                category: "", // сбрасываем подкатегорию при смене типа
                            })
                        }
                    >
                        <option value="business">Бізнес</option>
                        <option value="personal">Особисті</option>
                    </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Підкатегорія</Form.Label>
                    {typeof renderSubcategorySelect === "function" ? (
                        renderSubcategorySelect({ transaction, onChange })
                    ) : (
                    <Form.Select
                        value={transaction?.category || ""}
                        onChange={(e) =>
                            onChange({ ...transaction, category: e.target.value })
                        }
                    >
                        <option value="">Не вибрано</option>
                        {(CATEGORIES[transaction.categoryType] || []).map((cat) => (
                            <option key={cat} value={cat}>
                                {cat}
                            </option>
                        ))}
                    </Form.Select>
                    )}
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Тип платежу</Form.Label>
                    <Form.Select
                        value={transaction?.paymentType || ""}
                        onChange={(e) =>
                            onChange({ ...transaction, paymentType: e.target.value })
                        }
                    >
                        <option value="cash">Готівка</option>
                        <option value="non-cash">Безготівковий платіж</option>
                    </Form.Select>
                </Form.Group>
            </Form>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={onClose}>Скасувати</Button>
            <Button variant="primary" onClick={onSave}>Зберегти</Button>
        </Modal.Footer>
    </Modal>
)};

export const DeleteTransactionModal = ({ show, onClose, onConfirm }) => (
    <Modal show={show} onHide={onClose}>
        <Modal.Header closeButton>
            <Modal.Title>Видалення</Modal.Title>
        </Modal.Header>
        <Modal.Body>Ви впевнені, що хочете видалити платіж?</Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={onClose}>Скасувати</Button>
            <Button variant="danger" onClick={onConfirm}>Видалити</Button>
        </Modal.Footer>
    </Modal>
);
